import React from 'react';
import Icon from '@mdi/react';
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js';
import * as S from './item-pagination.styles';

export interface ItemPaginationProps {
    currentIndex: number;
    total: number;
    onPrevious: () => void;
    onNext: () => void;
    isNavigating?: boolean;
    size?: 'small' | 'medium';
    className?: string;
}

export const ItemPagination: React.FC<ItemPaginationProps> = ({
    currentIndex,
    total,
    onPrevious,
    onNext,
    isNavigating = false,
    size = 'small',
    className,
}) => {
    const canGoPrevious = currentIndex > 0 && !isNavigating;
    const canGoNext = currentIndex < total - 1 && !isNavigating;
    const iconSize = size === 'small' ? 0.8 : 1;

    if (total <= 0) {
        return null;
    }

    return (
        <S.Container size={size} className={className}>
            <S.NavigationButton
                size={size}
                onClick={onPrevious}
                disabled={!canGoPrevious}
                aria-label="Go to previous item"
                type="button"
            >
                <Icon path={mdiChevronLeft} size={iconSize} />
            </S.NavigationButton>

            <S.CounterText size={size}>
                {currentIndex + 1}/{total}
            </S.CounterText>

            <S.NavigationButton
                size={size}
                onClick={onNext}
                disabled={!canGoNext}
                aria-label="Go to next item"
                type="button"
            >
                <Icon path={mdiChevronRight} size={iconSize} />
            </S.NavigationButton>
        </S.Container>
    );
};

